module.exports = __webpack_public_path__ + "img/Sagittarius.951aad28.png";